module.exports = "pegasus_template/assets/blocks/social-2-theme3.png";